import { CLEAR_DATA, LIST_ONDEMAND_HEALTH_RECORD_REQUEST, LIST_ONDEMAND_HEALTH_RECORD_REQUEST_ERROR, LIST_ONDEMAND_HEALTH_RECORD_REQUEST_SUCCESS, ONDEMAND_HEALTH_RECORD_REQUEST, ONDEMAND_HEALTH_RECORD_REQUEST_ERROR, ONDEMAND_HEALTH_RECORD_REQUEST_SUCCESS, ONDEMAND_REQUEST, ONDEMAND_REQUEST_ERROR, ONDEMAND_REQUEST_SUCCESS } from './Constants';

// userReducer.js
const initialState = {
    loading: false,
    error: null,
};
  
export const ondemandReducer = (state = initialState, action) => {
    switch (action.type) {
    case ONDEMAND_REQUEST:        
        return { ...state,loading: true };
    case ONDEMAND_REQUEST_SUCCESS :                
        return { ...state, successData : action.data, loading: false };
    case ONDEMAND_REQUEST_ERROR :
        return { ...state,loading: false };
    case CLEAR_DATA:
        return { ...state, successData : null, uploadSuccess : null, loading: false };
    case LIST_ONDEMAND_HEALTH_RECORD_REQUEST:        
        return { ...state,loading: true };
    case LIST_ONDEMAND_HEALTH_RECORD_REQUEST_SUCCESS :                
        return { ...state, healthRecordList : action.data, loading: false };
    case LIST_ONDEMAND_HEALTH_RECORD_REQUEST_ERROR :
        return { ...state,loading: false };
    case ONDEMAND_HEALTH_RECORD_REQUEST:        
        return { ...state,loading: true };
    case ONDEMAND_HEALTH_RECORD_REQUEST_SUCCESS :                
        return { ...state, uploadSuccess : action.data, loading: false };
    case ONDEMAND_HEALTH_RECORD_REQUEST_ERROR :
        return { ...state,loading: false };
    default:
        return state;
    }
};
  